<template>
<!--  <div style="height: 100%;background-color: #fbfbfb">-->
<!--    <iframe id="mainIframe"-->
<!--            ref="mainIframe"-->
<!--            name="mainIframe"-->
<!--            style="width: 100%;height: 100%;margin: auto"-->
<!--            src="http://112.64.165.250:7070/index.html#/FoodWeekMenuView?template=self"-->
<!--            frameborder="0"-->
<!--            scrolling="no">-->
<!--    </iframe>-->
<!--  </div>-->
  <div style="height: 100%;background-color: #fbfbfb;padding: 20px;box-sizing: border-box">
    <div style="min-height: 50px">
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd" style=" width: 250px"></el-date-picker>
      <el-select v-fixZoom v-model="devicesn" style="width: 310px;" multiple placeholder="请选择门禁" @change="changetype">
        <el-option v-for="item in faceDevices" :key="item.devicesn" :label="item.name" :value="item.devicesn"></el-option>
      </el-select>
      <el-autocomplete style="width: 310px" class="inline-input" v-model="personid"
                       :fetch-suggestions="querySearch" placeholder="输入老人名称" :trigger-on-focus="false" @select="handleSelect">
      </el-autocomplete>
      <el-button type="success" @click="queryDataTable">查询</el-button>
    </div>
    <div style="height: calc(100% - 50px);overflow-y: auto;">
      <el-table height="100%" v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable" border style="width: 100%" highlight-current-row>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="DeviceSn" label="门禁编号" min-width="130" align="center"></el-table-column>
        <el-table-column prop="name" label="门禁名称" min-width="100" align="center">
          <template slot-scope="scope">
            <span>{{getDeviceName(scope.row.DeviceSn)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Name" label="人员" min-width="130" align="center"></el-table-column>
        <el-table-column prop="RecordTime" label="记录时间" min-width="140" align="center"></el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height:40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {facedevice, facedevicelog, searchelderly} from '../../api/yanglaoyuan'

export default {
  name: 'doorRecord',
  data () {
    return {
      sendDate: [],
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        shortcuts: []
      },
      devicesn: [],
      personid: '',
      sendData: {
        devicesn: '',
        personid: ''
      },
      faceDevices: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0
    }
  },
  mounted () {
    // window.open('https://www.yunatt.com/accessRecord/index', '_blank')
    // setTimeout(() => {
    //   history.back()
    // }, 500)
  },
  created () {
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-30)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
    this.queryDataFace()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    changetype (val) {
      console.log(val)
      let devicesn = ''
      val.forEach(item => {
        if (devicesn === '') {
          devicesn = item
        } else {
          devicesn = devicesn + ',' + item
        }
      })
      this.sendData.devicesn = devicesn
    },
    handleSelect (item) {
      this.sendData.personid = item.id
      console.log(item)
      // console.log('item', item)
      // this.addEditForm.did = item.id
      // this.addEditForm.deviceid = item.deviceid
      // this.addEditForm.phone = item.simcardno
      // this.isHome = !(item.dtype === 300 || item.dtype === 901 || item.dtype === 350)
      // this.isEdit = !(item.simcardno === '' || item.simcardno.length !== 11)
      // this.isShow = true
    },
    querySearch (queryString, cb) {
      if (queryString.length < 1) {
        let arr = []
        cb(arr)
        return
      }

      let params = {
        page: 1,
        size: 999
      }
      let data = {
        name: queryString
      }
      searchelderly(params, data).then(res => {
        let re = []
        let vm = this
        res.data.elderly.forEach(item => {
          re.push({
            value: item.elderly_name + ' - ' + vm.formatIDCard(item.id_number),
            id: item.id
          })
        })
        cb(re)
      }).catch(() => {
        let arr = []
        cb(arr)
      })
    },
    formatIDCard (card) {
      // 身份证号脱敏，展示前4后4
      return card !== '' ? card.replace(/^(.{4})(?:\d+)(.{4})$/, '$1**********$2') : ''
    },
    queryDataFace () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      facedevice(data).then(res => {
        this.faceDevices = res.data.devices
        let devicesn = ''
        this.faceDevices.forEach(item => {
          this.devicesn.push(item.devicesn)
          if (devicesn === '') {
            devicesn = item.devicesn
          } else {
            devicesn = devicesn + ',' + item.devicesn
          }
        })
        this.sendData.devicesn = devicesn
        if (devicesn !== '') {
          this.queryDataTable()
        }
      }).catch(() => {})
    },
    queryDataTable () {
      if (this.sendData.devicesn === '') {
        return
      }
      this.loading = true
      let data = {
        orgid: this.$store.state.user.orgid,
        devicesn: this.sendData.devicesn,
        personid: this.sendData.personid + '',
        pageindex: this.currentPage,
        pagesize: this.pageSize,
        starttime: this.sendDate[0] + ' 00:00:00',
        endtime: this.sendDate[1] + ' 23:59:59'
      }
      facedevicelog(data).then(res => {
        this.showTable = res.data.records
        this.totalCells = res.data.totalCount
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    },
    getDeviceName (DeviceSn) {
      let name = ''
      this.faceDevices.forEach(item => {
        if (item.devicesn === DeviceSn) {
          name = item.name
        }
      })
      return name
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/doorRecord.vue